import AppStoreIcon from '@/assets/Icons/app-store-big.svg';
import GooglePlayIcon from '@/assets/Icons/google-play-big.svg';
import styled from 'styled-components';
import Image from 'next/image';
import { resolvePath } from '@/utils/resolvePath';
import { useState, useContext, useEffect } from 'react';
import { useRouter } from 'next/router';
import { HOSTNAME } from '@/constants/constantsAckoDrive';
import { DeviceContext } from '@/pages/_app';
import ViewMore from '@/components/seoPages/ViewMore';

const Footer = ({
    cities,
    garage,
    hasBottomCTA = true,
    showOnlyLogo = false,
}: {
    cities?: any;
    garage?: string;
    hasBottomCTA?: boolean;
    showOnlyLogo?: boolean;
}) => {
    const router = useRouter();
    const isRobot = useContext(DeviceContext).isRobot;
    const [showCityLinks, setShowCityLinks] = useState(true);
    const [showLocationLinks, setShowLocationLinks] = useState(true);
    const [showAboutLinks, setShowAboutLinks] = useState(true);
    const [showAllLocations, setShowAllLocations] = useState(true);
    useEffect(() => {
        if (!isRobot) {
            setShowAboutLinks(false);
            setShowLocationLinks(false);
            setShowCityLinks(false);
            setShowAllLocations(false);
        }
    }, []);
    const { city }: any = router.query;

    let locations = city && cities?.[city?.toLocaleLowerCase()]?.localities;
    return (
        <>
            <FooterWrapper hasBottomCTA={hasBottomCTA}>
                <FooterContainer>
                    <ADSCLogo>
                        <Image
                            src={resolvePath('/images/ad-logo.svg')}
                            width={94}
                            height={32}
                            alt="Company logo"
                        />
                    </ADSCLogo>
                    {!showOnlyLogo && (
                        <LinkWrapper>
                            {locations &&
                                Object.keys(locations).length > 0 &&
                                cities[city?.toLocaleLowerCase()]
                                    ?.localities && (
                                    <LinkContainer>
                                        <LinkBox>
                                            <LinkHeadWrapper
                                                onClick={() =>
                                                    setShowLocationLinks(
                                                        !showLocationLinks
                                                    )
                                                }
                                            >
                                                <LinkHeading>
                                                    {/* {`Popular localities we operate in ${
                                                    cities[city]?.name
                                                }`} */}
                                                    Popular localities we
                                                    operate
                                                </LinkHeading>
                                                <Image
                                                    src={resolvePath(
                                                        '/images/seo/Chevron-down-black.svg'
                                                    )}
                                                    width={24}
                                                    height={12}
                                                    alt="Chevron-down"
                                                    style={
                                                        showLocationLinks
                                                            ? {}
                                                            : {
                                                                  transform:
                                                                      'rotate(180deg)',
                                                              }
                                                    }
                                                />
                                            </LinkHeadWrapper>
                                            {showLocationLinks && (
                                                <LinksBodyContainer>
                                                    {locations &&
                                                        Object.keys(locations)
                                                            .slice(
                                                                0,
                                                                showAllLocations
                                                                    ? Object.keys(
                                                                          locations
                                                                      ).length
                                                                    : 5
                                                            )
                                                            .map((l) => {
                                                                return (
                                                                    <LinkText
                                                                        onClick={(
                                                                            e
                                                                        ) => {
                                                                            e.preventDefault();
                                                                            router.push(
                                                                                `/${city}/${l}`
                                                                            );
                                                                        }}
                                                                        href={`${process.env.NEXT_PUBLIC_ENV_PREFIX}/${city}/${l}`}
                                                                    >
                                                                        {`Car
                                                                        Service
                                                                        Centre in 
                                                                        ${l
                                                                            ?.replace(
                                                                                /-/g,
                                                                                ' '
                                                                            )
                                                                            .split(
                                                                                ' '
                                                                            )
                                                                            .map(
                                                                                (
                                                                                    word,
                                                                                    index
                                                                                ) =>
                                                                                    index ===
                                                                                        0 &&
                                                                                    word?.length <
                                                                                        4
                                                                                        ? word.toUpperCase()
                                                                                        : word
                                                                                              .charAt(
                                                                                                  0
                                                                                              )
                                                                                              .toUpperCase() +
                                                                                          word
                                                                                              .slice(
                                                                                                  1
                                                                                              )
                                                                                              .toLowerCase()
                                                                            )
                                                                            .join(
                                                                                ' '
                                                                            )}`}
                                                                    </LinkText>
                                                                );
                                                            })}
                                                    {locations &&
                                                        Object.keys(locations)
                                                            .length > 5 && (
                                                            <ViewMore
                                                                handleViewMoreClick={() =>
                                                                    setShowAllLocations(
                                                                        (
                                                                            prev
                                                                        ) =>
                                                                            !prev
                                                                    )
                                                                }
                                                                text={
                                                                    showAllLocations
                                                                        ? 'view less'
                                                                        : 'view more'
                                                                }
                                                            />
                                                        )}
                                                </LinksBodyContainer>
                                            )}
                                        </LinkBox>
                                    </LinkContainer>
                                )}
                            {cities && (
                                <LinkContainer>
                                    <LinkBox>
                                        <LinkHeadWrapper
                                            onClick={() =>
                                                setShowCityLinks(!showCityLinks)
                                            }
                                        >
                                            <LinkHeading>
                                                Popular cities where we operate
                                            </LinkHeading>
                                            <Image
                                                src={resolvePath(
                                                    '/images/seo/Chevron-down-black.svg'
                                                )}
                                                width={24}
                                                height={12}
                                                alt="Chevron-down"
                                                style={
                                                    showCityLinks
                                                        ? {}
                                                        : {
                                                              transform:
                                                                  'rotate(180deg)',
                                                          }
                                                }
                                            />
                                        </LinkHeadWrapper>
                                        {showCityLinks && (
                                            <LinksBodyContainer>
                                                {cities &&
                                                    Object.keys(cities).map(
                                                        (l) => {
                                                            if (
                                                                city?.toLowerCase() ===
                                                                l
                                                            ) {
                                                                return;
                                                            }
                                                            return (
                                                                <LinkText
                                                                    onClick={(
                                                                        e
                                                                    ) => {
                                                                        e.preventDefault();
                                                                        router.push(
                                                                            `/${l}`
                                                                        );
                                                                    }}
                                                                    href={`${process.env.NEXT_PUBLIC_ENV_PREFIX}/${l}`}
                                                                >
                                                                    {`Car Service
                                                                    Centre in 
                                                                    ${
                                                                        cities[
                                                                            l
                                                                        ]
                                                                            ?.name ||
                                                                        l
                                                                    }`}
                                                                </LinkText>
                                                            );
                                                        }
                                                    )}
                                            </LinksBodyContainer>
                                        )}
                                    </LinkBox>
                                </LinkContainer>
                            )}
                            <LinkContainer>
                                <LinkBox>
                                    <LinkHeadWrapper
                                        onClick={() =>
                                            setShowAboutLinks(!showAboutLinks)
                                        }
                                    >
                                        <LinkHeading>About Us</LinkHeading>
                                        <Image
                                            src={resolvePath(
                                                '/images/seo/Chevron-down-black.svg'
                                            )}
                                            width={24}
                                            height={12}
                                            alt="Chevron-down"
                                            style={
                                                showAboutLinks
                                                    ? {}
                                                    : {
                                                          transform:
                                                              'rotate(180deg)',
                                                      }
                                            }
                                        />
                                    </LinkHeadWrapper>
                                    {showAboutLinks && (
                                        <LinksBodyContainer>
                                            <LinkText
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    router.push(
                                                        `/ad-services/schedule-callback`
                                                    );
                                                }}
                                                href={`${process.env.NEXT_PUBLIC_ENV_PREFIX}/ad-services/schedule-callback`}
                                            >
                                                FAQs
                                            </LinkText>
                                            <LinkText
                                                href={`${HOSTNAME}/contact-us/`}
                                            >
                                                Contact Us
                                            </LinkText>
                                            <LinkText
                                                href={`${HOSTNAME}/terms-and-conditions/`}
                                            >
                                                Terms and Conditions
                                            </LinkText>
                                            <LinkText
                                                href={`${HOSTNAME}/privacy-policy/`}
                                            >
                                                Privacy Policy
                                            </LinkText>
                                        </LinksBodyContainer>
                                    )}
                                </LinkBox>
                            </LinkContainer>
                        </LinkWrapper>
                    )}
                    {/* <socialswrapper>
                        <socialscontainer>
                            <socialstext>we’re socially active</socialstext>
                            <socialsicons>
                                <image
                                    src={resolvepath(
                                        '/images/seo/instagram_fill.svg'
                                    )}
                                    width={32}
                                    height={32}
                                    alt="instagram logo"
                                />
                                <image
                                    src={resolvepath(
                                        '/images/seo/linkedin_fill.svg'
                                    )}
                                    width={32}
                                    height={32}
                                    alt="linkedin logo"
                                />
                                <image
                                    src={resolvepath(
                                        '/images/seo/twitter_fill.svg'
                                    )}
                                    width={32}
                                    height={32}
                                    alt="twitter logo"
                                />
                                <image
                                    src={resolvepath(
                                        '/images/seo/youtube_fill.svg'
                                    )}
                                    width={32}
                                    height={32}
                                    alt="youtube logo"
                                />
                                <image
                                    src={resolvepath(
                                        '/images/seo/facebook_fill.svg'
                                    )}
                                    width={32}
                                    height={32}
                                    alt="facebook logo"
                                />
                            </socialsicons>
                        </socialscontainer>
                    </socialswrapper> */}
                    {/* <AppsWrapper>
                        <AppStoreIcon />
                        <GooglePlayIcon />
                    </AppsWrapper> */}
                </FooterContainer>
            </FooterWrapper>
        </>
    );
};

export default Footer;

const AppsWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    align-self: stretch;
`;

const SocialsIcons = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    gap: 16px;
    align-self: stretch;
`;

const SocialsText = styled.div`
    color: #121212;
    font-family: 'Euclid Circular B';
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px;
`;

const SocialsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-end;
`;

const SocialsContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 20px;
`;

const LinkText = styled.a`
    color: #121212;
    text-decoration: none;
    font-family: 'Euclid Circular B';
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
`;

const LinksBodyContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
    align-self: stretch;
`;

const LinkHeading = styled.div`
    color: #121212;
    font-family: 'Euclid Circular B';
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
`;

const LinkHeadWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    align-self: stretch;
`;

const LinkBox = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 24px;
    align-self: stretch;
`;

const LinkContainer = styled.div`
    display: flex;
    padding: 16px;
    flex-direction: column;
    align-items: flex-start;
    align-self: stretch;
    border-radius: 12px;
    background: #fff;
`;

const LinkWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
    align-self: stretch;
`;

const ADSCLogo = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 24px;
`;

const FooterContainer = styled.div`
    display: flex;
    padding: 32px 0px;
    flex-direction: column;
    align-items: flex-start;
    gap: 32px;
    align-self: stretch;
`;

const FooterWrapper = styled.div<{ hasBottomCTA: boolean }>`
    display: flex;
    padding: ${({ hasBottomCTA }) =>
        hasBottomCTA ? '0px 16px 72px' : '0 16px'};
    flex-direction: column;
    align-items: flex-start;
    gap: 32px;
    background: #f5f5f5;
`;
